module.exports = __webpack_public_path__ + "static/media/i-wishlist.95642d1f.png";